var map = {
	"./de.json": [
		"./src/assets/cl-console-components/i18n/de.json",
		3
	],
	"./en.json": [
		"./src/assets/cl-console-components/i18n/en.json",
		4
	],
	"./fr.json": [
		"./src/assets/cl-console-components/i18n/fr.json",
		5
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/cl-console-components/i18n lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;